import React from 'react';
import { NavLink } from 'react-router-dom';
import { LayoutDashboard, Users, MessageSquare, Radio, BarChart3, Settings as SettingsIcon, X, Shield } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export function Sidebar({ mobileOpen, setMobileOpen }) {
  const { user } = useAuth();

  const navItems = [
    { label: 'Dashboard', path: '/dashboard', icon: LayoutDashboard },
    { label: 'Leads', path: '/leads', icon: Users },
    { label: 'Chat Logs', path: '/chatbot', icon: MessageSquare },
    { label: 'Channels', path: '/channels', icon: Radio },
    { label: 'Reports', path: '/reports', icon: BarChart3 },
    { label: 'Settings', path: '/settings', icon: SettingsIcon }
  ];

  const content = (
    <aside
      style={{
        width: 'var(--sidebar-width)',
        height: '100vh',
        backgroundColor: 'var(--sidebar-bg)',
        borderRight: '1px solid var(--sidebar-border)',
        display: 'flex',
        flexDirection: 'column',
        position: 'fixed',
        top: 0,
        left: 0,
        zIndex: 900
      }}
    >
      {/* TBS Marketing Brand Logo Header */}
      <div
        style={{
          padding: '16px 18px 14px',
          borderBottom: '1px solid var(--sidebar-border)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between'
        }}
      >
          {/* TBS Brand Logo & Original Text Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div style={{ position: 'relative', flexShrink: 0 }}>
              <img
                src="/TBS-Logo.png"
                alt="TBS Logo"
                onError={(e) => {
                  e.currentTarget.style.display = 'none';
                  if (e.currentTarget.nextElementSibling) {
                    e.currentTarget.nextElementSibling.style.display = 'flex';
                  }
                }}
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '8px',
                  objectFit: 'contain',
                  backgroundColor: '#FFFFFF',
                  padding: '2px'
                }}
              />
              <div
                style={{
                  width: 36,
                  height: 36,
                  borderRadius: '8px',
                  backgroundColor: '#2cabe1',
                  color: '#FFFFFF',
                  display: 'none',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontWeight: 900,
                  fontSize: '15px',
                  boxShadow: '0 0 14px rgba(44, 171, 225, 0.45)',
                  flexShrink: 0
                }}
              >
                TBS
              </div>
            </div>

            <div>
              <div style={{ fontSize: '13.5px', fontWeight: 800, color: '#FFFFFF', letterSpacing: '-0.01em', fontFamily: 'var(--font-heading)', lineHeight: 1.2 }}>
                TBS MARKETING
              </div>
              <div style={{ fontSize: '10.5px', color: '#94A3B8', marginTop: '2px', lineHeight: 1.2 }}>
                Royal Phuket Marina & JLL
              </div>
            </div>
          </div>

        {mobileOpen && (
          <button onClick={() => setMobileOpen(false)} style={{ background: 'none', border: 'none', color: '#94A3B8', cursor: 'pointer' }}>
            <X size={18} />
          </button>
        )}
      </div>

      {/* Navigation Links */}
      <nav style={{ flex: 1, padding: '16px 10px', display: 'flex', flexDirection: 'column', gap: '3px' }}>
        {navItems.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setMobileOpen(false)}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: '9px 12px',
                borderRadius: '6px',
                color: isActive ? '#FFFFFF' : '#94A3B8',
                backgroundColor: isActive ? '#1E293B' : 'transparent',
                borderLeft: isActive ? '3px solid #2cabe1' : '3px solid transparent',
                fontWeight: isActive ? 600 : 400,
                fontSize: '13.5px',
                transition: 'all 0.15s ease'
              })}
            >
              <Icon size={16} color="currentColor" />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      {/* User Profile Badge & Copyright Footer */}
      <div style={{ padding: '14px 16px', borderTop: '1px solid var(--sidebar-border)', display: 'flex', flexDirection: 'column', gap: '10px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <div style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#2cabe1', color: '#FFFFFF', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: '11.5px', flexShrink: 0 }}>
            {user?.avatar || 'TS'}
          </div>
          <div style={{ overflow: 'hidden' }}>
            <div style={{ fontSize: '12px', fontWeight: 600, color: '#FFFFFF', whiteSpace: 'nowrap', textOverflow: 'ellipsis', overflow: 'hidden' }}>
              {user?.name || 'TBS Administrator'}
            </div>
            <div style={{ fontSize: '10.5px', color: '#83c341', display: 'flex', alignItems: 'center', gap: '3px', fontWeight: 600 }}>
              <Shield size={10} /> {user?.role || 'Admin'}
            </div>
          </div>
        </div>

        <div style={{ fontSize: '10px', color: '#64748B', textAlign: 'center', paddingTop: '4px', borderTop: '1px solid #1E293B' }}>
          © 2026 TBS Marketing Co., Ltd.
        </div>
      </div>
    </aside>
  );

  return (
    <>
      <div className="desktop-sidebar-wrapper" style={{ display: 'block' }}>
        {content}
      </div>

      {mobileOpen && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 1000, backgroundColor: 'rgba(0,0,0,0.5)' }}
          onClick={() => setMobileOpen(false)}
        >
          {content}
        </div>
      )}
    </>
  );
}
